import { useQuery } from 'react-query';

import { queryKeys } from './queryKeys';
import { fetchAdminInfo } from '../requests/fetchAdminInfo';

export const useAdminInfoQuery = ({ companyId }, options) =>
  useQuery(queryKeys.adminInfo(companyId), () => fetchAdminInfo(companyId), {
    enabled: Boolean(companyId),
    initialData: [],
    ...options,
  });
